.logo {
  width: 64px;
  height: 64px;
  color: var(--color-brand);
}
.leftStrip,
.rightStrip {
  animation: film var(--duration-loader) linear infinite;
}
@keyframes film {
  to {
    transform: translateY(26px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .leftStrip,
  .rightStrip {
    animation: none;
  }
}

.logo[data-paused] .leftStrip,
.logo[data-paused] .rightStrip {
  animation: none;
}
